import { AbstractEntity, PropertyValuesDictionary, Transaction, UiData } from "plethora-lib" // GENERATED
import {
  DataTypeShapeType,
  DataTypeDirection,
  DataTypeSize,
  DataTypeColor,
} from "../GeneratedClasses/GeneratedDataTypes" // GENERATED
import { GeneratedHunter } from "../GeneratedClasses/GeneratedHunter" // GENERATED

export class Hunter extends GeneratedHunter {
  constructor(id: number, propertyValues: PropertyValuesDictionary, uiData: UiData) {
    super(id, propertyValues, uiData)

    // YOUR CREATE CODE HERE
    const data = {
      id: this.id,
      posX: this.getX(),
      posY: this.getY(),
      direction: this.getDirection(),
    }
    gameInstance.SendMessage("GridManager", "CreateHanterPlethora", JSON.stringify(data))
  }

  public onDelete(uiData: UiData): void /* GENERATED */ {
    super.onDelete(uiData)
    gameInstance.SendMessage("GridManager", "DestroyHunterOrHelper", this.id)
    // YOUR CODE HERE
  }

  public onDestory(): void /* GENERATED */ {
    super.onDestory()
    // YOUR CODE HERE
  }

  public onSetHighlight(highlight: boolean): void /* GENERATED */ {
    super.onSetHighlight(highlight)
    // YOUR CODE HERE
  }

  protected onDirectionUpdate(
    newValue: DataTypeDirection,
    oldValue: DataTypeDirection,
    uiData: UiData
  ): void /* GENERATED */ {
    // YOUR CODE HERE
    gameInstance.SendMessage("GridManager", "OnHanterDirectionUpdate", newValue)
  }

  protected onXUpdate(newValue: number, oldValue: number, uiData: UiData): void /* GENERATED */ {
    // YOUR CODE HERE
  }

  protected onYUpdate(newValue: number, oldValue: number, uiData: UiData): void /* GENERATED */ {
    // YOUR CODE HERE
  }

  protected onTurnDown(uiData: UiData): void /* GENERATED */ {
    gameInstance.SendMessage("GridManager", "HanterRotateToFromPlethora", "down")
  }

  protected onTurnUp(uiData: UiData): void /* GENERATED */ {
    gameInstance.SendMessage("GridManager", "HanterRotateToFromPlethora", "up")
  }

  protected onTurnRight(uiData: UiData): void /* GENERATED */ {
    gameInstance.SendMessage("GridManager", "HanterRotateToFromPlethora", "right")
  }

  protected onTurnLeft(uiData: UiData): void /* GENERATED */ {
    gameInstance.SendMessage("GridManager", "HanterRotateToFromPlethora", "left")
  }

  protected onStep1(uiData: UiData): void /* GENERATED */ {
    gameInstance.SendMessage("GridManager", "OnPlayerStep", 1)
  }

  protected onStep3(uiData: UiData): void /* GENERATED */ {
    gameInstance.SendMessage("GridManager", "OnPlayerStep", 3)
  }

  protected onStep2(uiData: UiData): void /* GENERATED */ {
    gameInstance.SendMessage("GridManager", "OnPlayerStep", 2)
  }

  protected onClick(uiData: UiData): void /* GENERATED */ {
    // YOUR CODE HERE
  }

  protected onMeets(isActivator: boolean, otherEntity: AbstractEntity, uiData: UiData): void /* GENERATED */ {
    // YOUR CODE HERE
  }
}
